import React from 'react';
import { ProgressBar as PloneProgressBar } from '@plone/components';
import { clsx } from 'clsx';
import './ProgressBar.scss';

export interface ESSProgressBarProps {
  variant?: 'default' | 'success' | 'warning' | 'error';
  size?: 'sm' | 'md' | 'lg';
  value?: number;
  className?: string;
  [key: string]: any; // Allow any props from @plone/components ProgressBar
}

/**
 * ESS ProgressBar Component
 *
 * A progress indicator component for showing completion status.
 * Wraps @plone/components ProgressBar with ESS design system styling.
 *
 * @example
 * ```tsx
 * import { ESSProgressBar } from './components/Atoms/ProgressBar';
 *
 * <ESSProgressBar
 *   variant="success"
 *   size="md"
 *   value={75}
 * />
 * ```
 */
export const ESSProgressBar: React.FC<ESSProgressBarProps> = ({
  variant = 'default',
  size = 'md',
  className,
  ...props
}) => {
  return (
    <div
      className={clsx(
        'ess-progressbar',
        `ess-progressbar--${variant}`,
        `ess-progressbar--${size}`,
        className,
      )}
    >
      <PloneProgressBar {...props} />
    </div>
  );
};

export default ESSProgressBar;
